import React from 'react';
import { Helmet } from 'react-helmet';
import { string } from 'prop-types';
import { useRouter } from 'next/router';
import { getCanonicalAttr } from 'utils/helmet';

const CategoryHelmet = ({ description, language, title }) => {
  const { asPath } = useRouter();

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link {...getCanonicalAttr(language, asPath)} />
    </Helmet>
  );
};

CategoryHelmet.propTypes = {
  description: string.isRequired,
  language: string.isRequired,
  title: string.isRequired,
};

export default CategoryHelmet;
